import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { Observable } from 'rxjs';

interface IAddSeuilDialogObjectProps {
  formObject: DynamicForm;
  action: () => void;
  isAddDisabled: Observable<boolean>;
  toggleVisibility: () => void;
}

export const getAddSeuilDialogObject = ({ formObject, action, isAddDisabled, toggleVisibility }: IAddSeuilDialogObjectProps): DialogObject => {
  return {
    title: 'settings.seuils.dialog.add.title',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.contractingAuthority.ac.form.add',
        onClick: () => action(),
        disabled: isAddDisabled,
      },
      {
        label: 'settings.contractingAuthority.ac.form.cancel',
        onClick: () => toggleVisibility(),
        variant: 'secondary',
      },
    ],
  };
};
